import dayjs from "dayjs";
import { ApiAction } from "@/types/Enums";
import i18ng from "@/i18n";
const { t } = i18ng.global;
const StringUtil = {
  /** String이 비어있는지 검증 */
  isEmpty(item?: string) {
    let sts = false;
    if (item === null || item === undefined || item === "") {
      sts = true;
    }
    return sts;
  },
  transYn(yn: string) {
    return yn === "Y";
  },
  transDate(dateStr: string, format: string) {
    if (StringUtil.isEmpty(dateStr)) {
      return "";
    }
    const parsed = dayjs(dateStr);
    return parsed.format(format);
  },
  getViewText(viewType: ApiAction) {
    if (viewType === ApiAction.REG) return t("viewType.REG");
    if (viewType === ApiAction.MODIFY) return t("viewType.MODIFY");
    return t("viewType.DETAIL");
  },
  /** email split */
  splitEmail(email: string): [string, string] {
    if (!email?.includes("@")) return ["", ""];
    return email.split("@") as [string, string];
  },

  /** split phone number */
  splitPhone(phone: string): [string, string, string] {
    const cleaned = phone.replace(/[^0-9]/g, ""); // 숫자만 남기기

    const p1 = cleaned.slice(0, 3);
    const p2 = cleaned.slice(3, 7);
    const p3 = cleaned.slice(7, 11);

    return [p1, p2, p3];
  },

  /** 날짜 포맷 변경
   * ex 20240504 -> 2024-05-04
   **/
  formatDate: (dateString: string) => {
    if (dateString.length === 8) {
      return `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`;
    }
    return dateString;
  },

  /** 시간 포맷 변경
   * ex 0900 -> 09:00
   **/
  formatTime: (time: string) => {
    if (time && time?.length === 4) {
      return time.slice(0, 2) + ":" + time.slice(2);
    }
    return time;
  },

  /** 2차원 String Array를 Json Array로 변환 */
  r2StringToJsonArr(r2String: string[][], mapper: string[]) {
    const returnArr = [] as Array<Record<string, string>>;

    r2String.forEach((item) => {
      const record = {} as Record<string, string>;
      item.forEach((data, idx) => {
        record[mapper[idx]] = data;
      });
      returnArr.push(record);
    });

    return returnArr;
  },
};

export default StringUtil;
